import { render } from "./ProjectItemComponent.vue?vue&type=template&id=6c3734cd&scoped=true&ts=true"
import script from "./ProjectItemComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectItemComponent.vue?vue&type=script&lang=ts"

import "./ProjectItemComponent.vue?vue&type=style&index=0&id=6c3734cd&lang=scss&scoped=true"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3734cd"]])

export default __exports__